import { GroundType } from 'models/ground';
import React from 'react';
import {
  Group, Line, Path, Text,
} from 'react-konva';
import {
  DEFAULT_PITCH_LINE_COLOR,
  DEFAULT_PITCH_STROKEWIDTH,
  HANDBALL_4,
  HANDBALL_4_LENGHT,
  HANDBALL_7,
  HANDBALL_7_LENGHT,
  HANDBALL_9,
  HANDBALL_AREA_WIDTH,
  HANDBALL_GOAL_HEIGTH,
} from '../constants';
import {
  rotate, flipPoint, computeAngle, flipX, flipY, describeArc, convertDegrees,
} from '../utils';
import Vertices from '../Vertices';

function Area(props: {
  vertexA: { x: number; y: number };
  vertexC: { x: number; y: number };
  height: number;
  center: { x: number; y: number };
  scale: number;
  flipped?: boolean;
}) {
  const {
    vertexA, vertexC, height, scale, flipped, center,
  } = props;

  const scaledAreaWidth = HANDBALL_AREA_WIDTH * scale;
  const scaledGoalHeight = HANDBALL_GOAL_HEIGTH * scale;
  const scaled9LineOffset = HANDBALL_9 * scale;
  const scaled7LineOffset = HANDBALL_7 * scale;
  const scaled4LineOffset = HANDBALL_4 * scale;
  const scaled9Line = HANDBALL_GOAL_HEIGTH * scale;
  const scaled7Line = HANDBALL_7_LENGHT * scale;
  const scaled4Line = HANDBALL_4_LENGHT * scale;

  const angle = convertDegrees(
    Math.asin(Math.sqrt(scaled9LineOffset ** 2 - (height / 2 - scaledGoalHeight / 2) ** 2) / scaled9LineOffset),
  );

  return (
    <Group>
      <Path
        data={describeArc(
          flipped ? vertexC.x : vertexA.x,
          flipped ? vertexC.y + height / 2 + scaledGoalHeight / 2 : vertexA.y - height / 2 - scaledGoalHeight / 2,
          scaled9LineOffset < 0 ? scaled9LineOffset * -1 : scaled9LineOffset,
          flipped ? 180 + angle : angle,
          flipped ? 270 : 90,
        )}
        dash={[5, 5]}
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
      />
      <Path
        data={describeArc(
          flipped ? vertexC.x - scaledAreaWidth : vertexA.x + scaledAreaWidth,
          vertexA.y - height / 2 + scaledAreaWidth + scaledGoalHeight / 2,
          scaledAreaWidth < 0 ? scaledAreaWidth * -1 : scaledAreaWidth,
          flipped ? 90 : 0,
          flipped ? 0 : -90,
        )}
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
      />
      <Line
        points={
          flipped
            ? [
              flipX({ x: vertexA.x + scaledAreaWidth, y: vertexA.y + scaledGoalHeight / 2 - height / 2 }, center),
              flipY({ x: vertexA.x + scaledAreaWidth, y: vertexA.y + scaledGoalHeight / 2 - height / 2 }, center),
              flipX({ x: vertexA.x + scaledAreaWidth, y: vertexA.y + scaledGoalHeight / 2 - height / 2 }, center),
              flipY({ x: vertexA.x + scaledAreaWidth, y: vertexA.y - scaledGoalHeight / 2 - height / 2 }, center),
            ]
            : [
              vertexA.x + scaledAreaWidth,
              vertexA.y + scaledGoalHeight / 2 - height / 2,
              vertexA.x + scaledAreaWidth,
              vertexA.y - scaledGoalHeight / 2 - height / 2,
            ]
        }
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
      />
      <Line
        points={
          flipped
            ? [
              flipX({ x: vertexA.x + scaled4LineOffset, y: vertexA.y + scaled4Line / 2 - height / 2 }, center),
              flipY({ x: vertexA.x + scaled4LineOffset, y: vertexA.y + scaled4Line / 2 - height / 2 }, center),
              flipX({ x: vertexA.x + scaled4LineOffset, y: vertexA.y + scaled4Line / 2 - height / 2 }, center),
              flipY({ x: vertexA.x + scaled4LineOffset, y: vertexA.y - scaled4Line / 2 - height / 2 }, center),
            ]
            : [
              vertexA.x + scaled4LineOffset,
              vertexA.y + scaled4Line / 2 - height / 2,
              vertexA.x + scaled4LineOffset,
              vertexA.y - scaled4Line / 2 - height / 2,
            ]
        }
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
      />
      <Line
        points={
          flipped
            ? [
              flipX({ x: vertexA.x + scaled7LineOffset, y: vertexA.y + scaled7Line / 2 - height / 2 }, center),
              flipY({ x: vertexA.x + scaled7LineOffset, y: vertexA.y + scaled7Line / 2 - height / 2 }, center),
              flipX({ x: vertexA.x + scaled7LineOffset, y: vertexA.y + scaled7Line / 2 - height / 2 }, center),
              flipY({ x: vertexA.x + scaled7LineOffset, y: vertexA.y - scaled7Line / 2 - height / 2 }, center),
            ]
            : [
              vertexA.x + scaled7LineOffset,
              vertexA.y + scaled7Line / 2 - height / 2,
              vertexA.x + scaled7LineOffset,
              vertexA.y - scaled7Line / 2 - height / 2,
            ]
        }
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
      />
      <Line
        points={
          flipped
            ? [
              flipX({ x: vertexA.x + scaled9LineOffset, y: vertexA.y + scaled9Line / 2 - height / 2 }, center),
              flipY({ x: vertexA.x + scaled9LineOffset, y: vertexA.y + scaled9Line / 2 - height / 2 }, center),
              flipX({ x: vertexA.x + scaled9LineOffset, y: vertexA.y + scaled9Line / 2 - height / 2 }, center),
              flipY({ x: vertexA.x + scaled9LineOffset, y: vertexA.y - scaled9Line / 2 - height / 2 }, center),
            ]
            : [
              vertexA.x + scaled9LineOffset,
              vertexA.y + scaled9Line / 2 - height / 2,
              vertexA.x + scaled9LineOffset,
              vertexA.y - scaled9Line / 2 - height / 2,
            ]
        }
        dash={[5, 5]}
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
      />
      <Line
        points={
          flipped
            ? [
              flipX({ x: vertexA.x + scaledAreaWidth, y: vertexA.y + scaledGoalHeight / 2 - height / 2 }, center),
              flipY({ x: vertexA.x + scaledAreaWidth, y: vertexA.y + scaledGoalHeight / 2 - height / 2 }, center),
              flipX({ x: vertexA.x + scaledAreaWidth, y: vertexA.y + scaledGoalHeight / 2 - height / 2 }, center),
              flipY({ x: vertexA.x + scaledAreaWidth, y: vertexA.y - scaledGoalHeight / 2 - height / 2 }, center),
            ]
            : [
              vertexA.x + scaledAreaWidth,
              vertexA.y + scaledGoalHeight / 2 - height / 2,
              vertexA.x + scaledAreaWidth,
              vertexA.y - scaledGoalHeight / 2 - height / 2,
            ]
        }
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
      />
      <Path
        data={describeArc(
          flipped ? vertexC.x : vertexA.x + scaledAreaWidth,
          flipped
            ? vertexC.y + height / 2 - scaledGoalHeight / 2
            : vertexC.y + height / 2 - scaledAreaWidth - scaledGoalHeight / 2,
          scaledAreaWidth < 0 ? scaledAreaWidth * -1 : scaledAreaWidth,
          flipped ? 270 : 270,
          flipped ? 0 : 180,
        )}
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
      />
      <Path
        data={describeArc(
          flipped ? vertexC.x : vertexA.x,
          flipped ? vertexC.y + height / 2 - scaledGoalHeight / 2 : vertexA.y - height / 2 + scaledGoalHeight / 2,
          scaled9LineOffset < 0 ? scaled9LineOffset * -1 : scaled9LineOffset,
          flipped ? 270 : 90,
          flipped ? -angle : 180 - angle,
        )}
        dash={[5, 5]}
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
      />
    </Group>
  );
}

export default function Handball(props: { groundData: GroundType; scale: number; vertices: boolean }) {
  const { groundData, scale, vertices } = props;

  let vertexA = {
    x:
      rotate(flipPoint({ x: groundData.vertexAX?.value, y: groundData.vertexAY?.value }, groundData),computeAngle(groundData)).x
      * scale,
    y:
      rotate(flipPoint({ x: groundData.vertexAX?.value, y: groundData.vertexAY?.value }, groundData),computeAngle(groundData)).y
      * scale,
  };
  let vertexC = {
    x:
      rotate(flipPoint({ x: groundData.vertexCX?.value, y: groundData.vertexCY?.value }, groundData),computeAngle(groundData)).x
      * scale,
    y:
      rotate(flipPoint({ x: groundData.vertexCX?.value, y: groundData.vertexCY?.value }, groundData),computeAngle(groundData)).y
      * scale,
  };

  if (vertexA.x > vertexC.x) {
    const swap = vertexC;
    vertexC = vertexA;
    vertexA = swap;
  }

  const width = vertexC.x - vertexA.x;
  const height = vertexA.y - vertexC.y;

  const center = { x: vertexA.x + width / 2, y: vertexA.y - height / 2 };

  return (
    <Group>
      {vertices ? <Vertices A={vertexA} C={vertexC} /> : null}
      {/* border */}
      <Line
        fill={groundData.groundSurfaceColor ? groundData.groundSurfaceColor : '#00000000'}
        points={[vertexA.x, vertexA.y, vertexC.x, vertexA.y, vertexC.x, vertexC.y, vertexA.x, vertexC.y]}
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
        closed
      />
      {/* left area */}
      <Area vertexA={vertexA} vertexC={vertexC} height={height} center={center} scale={scale} />
      {/* halfcourt */}
      <Line
        points={[vertexA.x + width / 2, vertexA.y, vertexC.x - width / 2, vertexC.y]}
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
      />
      {/* rightarea */}
      <Area vertexA={vertexA} vertexC={vertexC} height={height} center={center} scale={scale} flipped />
    </Group>
  );
}
